import React, { useEffect, useState } from 'react';
import { Card, Table, Badge, Row, Col, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useToken from '../../hooks/useToken';
import { Link } from 'react-router-dom';

const SubscriptionProducts = ({ idSuscripcion }) => {
    const { token } = useToken();
    const [productos, setproductos] = useState([]);
    const [totales, setTotales] = useState({});
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const tamanioPagina = 4;

    const ObtenerProdutos = async (pageNumber = 1) => {
        if (!idSuscripcion) return;
        setIsLoading(true);

        try {
            const response = await fetch('/api/Suscripciones/ObtenerSubscriptionProducts', {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idSuscripcion: parseInt(idSuscripcion),
                    pageNumber: pageNumber,
                    pageSize: tamanioPagina
                })
            });
            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    const detalles = ObjDetalles.table3 || ObjDetalles.Table3 || ObjDetalles.table1 || ObjDetalles.Table1 || [];
                    const globales = (ObjDetalles.table2 || ObjDetalles.Table2 || [])[0] || {};

                    if (detalles.length > 0) {
                        if (pageNumber === 1) {
                            setproductos(detalles);
                            setTotales(globales);
                        } else {
                            setproductos(prev => [...prev, ...detalles]);
                        }

                        if (detalles.length < tamanioPagina) {
                            setHasMore(false);
                        } else {
                            setHasMore(true);
                        }
                    } else {
                        if (pageNumber === 1) {
                            setproductos([]);
                            setTotales({});
                        }
                        setHasMore(false);
                    }
                } else {
                    console.log("Error al obtener datos:", data.vMessage);
                    setHasMore(false);
                }
            } else {
                console.log("Error en la respuesta del servidor");
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error de conexión", error);
            setHasMore(false);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (idSuscripcion) {
            setPagina(1);
            setHasMore(true);
            setproductos([]);
            ObtenerProdutos(1);
        }
    }, [idSuscripcion]);

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 50;
        if (bottom && hasMore && !isLoading) {
            const nextPage = pagina + 1;
            setPagina(nextPage);
            ObtenerProdutos(nextPage);
        }
    };


    const totalSubtotal = totales.GlobalImporte || 0;
    const totalIVA = totales.GlobalIVA || 0;
    const totalGeneral = totales.GlobalTotal || 0;

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value || 0);
    };

    return (
        <Card className="shadow-sm border-0 mb-4">
            <Card.Header className="bg-white border-bottom pt-4 pb-3 d-flex justify-content-between align-items-center">
                <h5 className="mb-0 fw-bold">
                    Productos de la Suscripción
                </h5>
                <Badge bg="primary" pill style={{ fontSize: '0.85rem' }}>
                    {totales.GlobalCount || productos.length || 0}
                </Badge>
            </Card.Header>
            <Card.Body className="p-0">
                <div
                    style={{ maxHeight: '290px', overflowY: 'auto' }}
                    onScroll={handleScroll}
                >
                    <Table hover className="mb-0 align-middle">
                        <thead className="bg-light text-muted sticky-top" style={{ fontSize: '0.75rem', letterSpacing: '0.5px', zIndex: 1 }}>
                            <tr>
                                <th className="border-0 ps-4 text-uppercase">Nombre Producto</th>
                                <th className="border-0 text-center text-uppercase">Cant.</th>
                                <th className="border-0 text-end text-uppercase">Prec. Unit.</th>
                                <th className="border-0 text-end text-uppercase">Importe</th>
                                <th className="border-0 text-end text-uppercase">IVA</th>
                                <th className="border-0 pe-4 text-end fw-bold text-dark text-uppercase">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.map((prod, index) => (
                                <tr key={index}>
                                    <td className="ps-4 py-3">
                                        <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.9rem' }}>{prod.vNombreProducto}</div>
                                        <div className="text-muted mb-1" style={{ fontSize: '0.8rem' }}>{prod.vCodigoBarras}</div>
                                        {prod.idLicencia && (
                                            <Link to={`/licencias/detalle/${prod.idLicencia}`} style={{ textDecoration: 'none' }}>
                                                <Badge bg="light" text="dark" className="border">
                                                    Lic #{prod.idLicencia}
                                                </Badge>
                                            </Link>
                                        )}
                                    </td>
                                    <td className="text-center" style={{ fontSize: '0.9rem' }}>{prod.dCantidad}</td>
                                    <td className="text-end" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.dPrecioUnitario)}</td>
                                    <td className="text-end" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.dImporte)}</td>
                                    <td className="text-end" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.dIVA)}</td>
                                    <td className="pe-4 text-end fw-semibold text-dark" style={{ fontSize: '0.9rem' }}>{formatCurrency(prod.dTotal)}</td>
                                </tr>
                            ))}
                            {productos.length === 0 && !isLoading && (
                                <tr>
                                    <td colSpan="6" className="text-center py-4 text-muted">
                                        No hay productos en esta suscripción.
                                    </td>
                                </tr>
                            )}
                            {isLoading && (
                                <tr>
                                    <td colSpan="6" className="text-center py-4">
                                        <Spinner animation="border" variant="primary" size="sm" />
                                        <span className="ms-2 text-muted">Cargando productos...</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {productos.length > 0 && (
                    <div className="d-flex justify-content-end p-4 border-top">
                        <div style={{ width: '250px' }}>
                            <Row className="mb-2">
                                <Col className="text-muted text-end" style={{ fontSize: '0.85rem' }}>Subtotal</Col>
                                <Col className="text-end fw-semibold text-dark" style={{ fontSize: '0.9rem' }}>{formatCurrency(totalSubtotal)}</Col>
                            </Row>
                            <Row className="mb-3">
                                <Col className="text-muted text-end" style={{ fontSize: '0.85rem' }}>(IVA 16%)</Col>
                                <Col className="text-end fw-semibold text-dark" style={{ fontSize: '0.9rem' }}>{formatCurrency(totalIVA)}</Col>
                            </Row>
                            <Row className="pt-3 border-top">
                                <Col className="text-dark fw-bold text-end" style={{ fontSize: '0.95rem' }}>Total</Col>
                                <Col className="text-end fw-bold text-dark" style={{ fontSize: '0.95rem' }}>{formatCurrency(totalGeneral)}</Col>
                            </Row>
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

SubscriptionProducts.propTypes = {
    idSuscripcion: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default SubscriptionProducts;